export class Constants {
    // The key used to access local storage for the user's login token.
    static UserLocalStorageTokenKey: string = "UserLocalStorageTokenKey"

    // The key used to access local storage for the user's refresh token.
    static UserLocalStorageRefreshTokenKey: string = "UserLocalStorageRefreshTokenKey"
}